import React, { useState, useEffect } from 'react';
import { useMediaQuery, TextField, Grid } from '@material-ui/core';

import AvatarPhoto from './AvatarPhoto';
import ButtonBase from '../../../../components/Buttons/ButtonBase';
import TitlesProfile from '../../../../components/Profile/TitlesProfile';
import { connect } from 'react-redux';
import { activeDeleteReset } from '../../../../store/actions/DeleteImageAction';
import { showLoading } from '../../../../store/actions/LoadingActions';
import { makeStyles } from '@material-ui/styles';
import Select from '../../../../components/SimpleSelect/Select';
import { storage } from '../../../../configs/environments/firebase/firebaseApp';
import municipios from '../../../../components/Profile/AddSite/estados-municipios.json';
import estados from '../../../../components/Profile/AddSite/estados.json';
import { cleanProposalData } from '../../../../store/actions/ProposalsAction';
import './ProposalLawyer.scss';

const maleAvatar = process.env.REACT_APP_AVATAR_MALE;
const femaleAvatar = process.env.REACT_APP_AVATAR_FEMALE;
const lawFirmAvatar = process.env.REACT_APP_AVATAR_LAWFIRM;


const useStyles = makeStyles({
  TextField: {
    maxWidth: 536,
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 192,
    minWidth: 'initial',
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
  linkStyle: {
    width: 192,
    margin: '0 24px 0 0',
    '&:last-child': {
      margin: 0,
    },
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
});

const ProposalLawyerForm = ({
  values,
  handleSubmit,
  handleChange,
  isValid,
  handleBlur,
  setFieldValue,
  resetForm,
  activeDeleteReset,
  uid,
  deleteImg,
  showLoading,
  touched,
  errors,
  setCreateView,
  cleanProposalData,
  urlImgLogo,
  role,
  genero,
}) => {
  
  const defaultAvatar =
      role === 'lawyer'
      ? genero === 'male'
          ? maleAvatar
          : femaleAvatar
      : lawFirmAvatar;


  const [availableState, setAvailableState] = useState(estados);
  const [availableCities, setAvailableCities] = useState([]);

  const handleStates = (field) => async (event) => {
    let states = event.target.value;
    let cities = await municipios[states];
    let datos = [];
    let objeto = {};
    for (let i in cities) {
      let municipios = cities[i];
      datos.push({ value: municipios, label: municipios });
    }
    objeto.datos = datos;
    setAvailableCities(datos);
    setFieldValue(field, states);
  };

  const handleCities = (field) => async (event) => {
    let value = event.target.value;
    setFieldValue(field, value);
  };

  useEffect(() => {
    (async function () {
      if (values.estado !== '') {
        let states = values.estado;
        let cities = await municipios[states];
        let datos = [];
        let objeto = {};
        for (let i in cities) {
          let municipios = cities[i];
          datos.push({ value: municipios, label: municipios });
        }
        objeto.datos = datos;
        setAvailableCities(datos);
      }
    })();
  }, [values.estado]);

  const isMobile = useMediaQuery('(max-width: 768px)');
  const classes = useStyles();

  const [cancelData, setCancelData] = useState(false);

  const handleCancel = (event) => {
    event.preventDefault();
    resetForm();
    if (!values.flagEdit) {
      values['proposalImgProfile'] = '';
      setCancelData(true);

      cleanProposalData();
      setCreateView(false);
      window.scroll(0, 0);
    } else {
      activeDeleteReset();

      cleanProposalData();
      setCreateView(false);
      window.scroll(0, 0);
    }
  };

  const addToFirebaseStorage = async (elem, routeName, subRouteName) => {
      return new Promise(async (resolve, reject) => {
        if (typeof values.proposalImgProfile === 'object') {
          try {
            if (Object.entries(elem).length <= 0) {
            let sPhoto = `CA_${Math.floor(Math.random() * Math.random())}${uid}`;
            await storage
              .ref(`proposalProfileImage/${uid}/${routeName}/${subRouteName}/${sPhoto}`)
              .put(elem)
              .on(
                'state_changed',
                snapShot => { },
                err => { },
                async () => {
                  try {
                    const getUrl = await storage
                      .ref(`proposalProfileImage/${uid}/${routeName}/`)
                      .child(`${subRouteName}/${sPhoto}`)
                      .getDownloadURL()
                    values['proposalImgProfile'] = getUrl
                    resolve(getUrl)
                  } catch (error) {
                    console.log('error 2',error);
                  }
                }
              )
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          resolve()
        }
      })
    }

  const deleteFromFirebaseStorage = () => {
    return new Promise((resolve, reject) => {
      if (
        urlImgLogo &&
        urlImgLogo.includes('firebase') &&
        deleteImg.proposalImgProfile
      ) {
      try {
        const response = storage
          .refFromURL(urlImgLogo)
          .delete()
        return resolve(response)
      } catch (error) {
        return reject(error);
      }
      } else {
        return resolve()
      }
    });
  };


  const someIsFile = () => {
    let isFile = false;
    if (typeof values.proposalImgProfile === 'object') {
      isFile = true;
    }
    return isFile;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    // showLoading()
    const isFile = someIsFile();
    try {
      if (
        urlImgLogo &&
        urlImgLogo !== maleAvatar &&
        urlImgLogo !== femaleAvatar &&
        urlImgLogo !== lawFirmAvatar
      ) {
        await deleteFromFirebaseStorage()
      }
      if (isFile) {
        await addToFirebaseStorage(
          values.proposalImgProfile,
          'main',
          'avatar'
        );
        setCancelData(true)
        activeDeleteReset()
        handleSubmit()
      } else {
        if (
          (values.proposalImgProfile && !values.proposalImgProfile.includes('firebase')) ||
          !values.proposalImgProfile
        ) {
          values['proposalImgProfile'] = defaultAvatar
        }
        activeDeleteReset()
        handleSubmit()
      }

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form className="ProposalLawyer_content">
      <div className="ProposalCover_content_section">
        <TitlesProfile
          title="Apariencia"
          subtitle="Puedes agregar la imagen de tu logo o mantener la imagen que nosotros te proporcionamos."
        />

        <AvatarPhoto
          name={'proposalImgProfile'}
          value={values.proposalImgProfile}
          setFieldValue={setFieldValue}
          cancelData={cancelData}
          setCancelData={setCancelData}
          flagEdit={values.flagEdit}
        />
      </div>

      <div className="ProposalCover_content_section">
        <TitlesProfile
          title="Sobre ti"
          subtitle="Mantén o cambia la información sobre ti. Estos cambios sólo se verán en la propuesta económica."
        />

        <Grid container direction="column">
          <TextField
            label="Nombre(s)*"
            id="name"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.name ? values.name : ''}
            helperText={touched.name && errors.name ? errors.name : ''}
            error={touched.name && errors.name ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />

          <TextField
            label="Apellidos(s)*"
            id="lastName"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.lastName ? values.lastName : ''}
            helperText={
              touched.lastName && errors.lastName ? errors.lastName : ''
            }
            error={touched.lastName && errors.lastName ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />

          <TextField
            label="Correo electrónico*"
            id="email"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.email ? values.email : ''}
            helperText={touched.email && errors.email ? errors.email : ''}
            error={touched.email && errors.email ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />

          <TextField
            label="Teléfono"
            id="phone"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }}
            inputProps={{ minLength: 10, maxLength: 10 }}
            value={values.phone ? values.phone : ''}
            helperText={
              touched.phone && errors.phone ? errors.phone : ''
            }
            error={touched.phone && errors.phone ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
        </Grid>
      </div>

      <div className="ProposalCover_content_section">
        <TitlesProfile
          title="Dirección"
          subtitle="Mantén o cambia la ubicación de tu centro de trabajo. Estos cambios sólo se verán en la propuesta económica."
        />

        <Grid container direction="column">
          <Select
            handleBlur={handleBlur}
            handleChange={handleStates('estado')}
            value={values.estado}
            touchedItems={touched.estado}
            errorsItems={errors.estado}
            items={availableState}
            textLabel="Estado*"
            className={classes.TextField}
            attrib="536px"
          />

          <Select
            handleBlur={handleBlur}
            handleChange={handleCities('municipio')}
            value={values.municipio}
            touchedItems={touched.municipio}
            errorsItems={errors.municipio}
            items={availableCities}
            textLabel="Municipio*"
            className={classes.TextField}
            attrib="536px"
          />

          <TextField
            label="Dirección*"
            id="address"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.address ? values.address : ''}
            helperText={touched.address && errors.address ? errors.address : ''}
            error={touched.address && errors.address ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
        </Grid>
      </div>

      <div className="ProposalBackCover_content_buttons">
        <ButtonBase
          type="submit"
          onClick={onSubmit}
          variant="primary"
          linkStyle={classes.linkStyle}
          className={classes.ButtonBase}
          //disabled={!isValid && values.proposalImgProfile}
        >
          {isMobile ? 'Guardar' : 'Guardar y continuar'}
        </ButtonBase>

        <ButtonBase
          type="submit"
          onClick={handleCancel}
          variant="primarySolidOutlined"
          linkStyle={classes.linkStyle}
          className={classes.ButtonBase}
        >
          Cancelar
        </ButtonBase>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  deleteImg: state.DeleteImageReducer.deleteImg,
  urlImgLogo:
    state.proposalsReducer.selectedProposal &&
    Object.values(state.proposalsReducer.selectedProposal).length > 0 ?
    state.proposalsReducer.selectedProposal.urlImgLogo :
    state.proposalsReducer.newProposalData.urlImgLogo,
  role: state.authClient.role,
  genero: state.authClient.genero,

});

const mapDispatchToProps = (dispatch) => ({
  showLoading: () => dispatch(showLoading()),
  activeDeleteReset: () => dispatch(activeDeleteReset()),
  cleanProposalData: () => dispatch(cleanProposalData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalLawyerForm);
